import React, { useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import {
  failedPaymentsRetryStatusSelector,
  failedPaymentsSelector,
} from 'selectors/app-selector';
import { paymentMethodsSelector } from 'selectors/booking-selectors';
import {
  getFailedPaymentsListAction,
  retryFailedPaymentsAction,
  setFailedPaymentsRetryStatusAction,
} from 'actions/app-actions';
import { POSTPAID_BILLING_TYPE } from 'constants/booking-constants';
import FailedPaymentsListModal from './failed-payments-list-modal';
import FailedPaymentsRetryModal from './failed-payments-retry-modal';

const FailedPayments = ({
  location,
  failedPayments,
  paymentMethods,
  failedPaymentsRetryStatus,
  getFailedPayments,
  retryFailedPayments,
  setFailedPaymentsRetryStatus,
}) => {
  const pathname = _get(location, 'pathname');

  useEffect(
    () => {
      getFailedPayments();
    },
    [pathname, getFailedPayments],
  );

  const paymentMethodFiltered = useMemo(
    () =>
      paymentMethods.filter(
        element => _get(element, 'type') !== POSTPAID_BILLING_TYPE,
      ),
    [paymentMethods],
  );

  return (
    <div>
      <FailedPaymentsListModal
        failedPayments={failedPayments}
        failedPaymentsRetryStatus={failedPaymentsRetryStatus}
        setFailedPaymentsRetryStatus={setFailedPaymentsRetryStatus}
        paymentMethods={paymentMethodFiltered}
      />
      <FailedPaymentsRetryModal
        failedPayments={failedPayments}
        failedPaymentsRetryStatus={failedPaymentsRetryStatus}
        setFailedPaymentsRetryStatus={setFailedPaymentsRetryStatus}
        paymentMethods={paymentMethodFiltered}
        retryFailedPayments={retryFailedPayments}
      />
    </div>
  );
};

FailedPayments.propTypes = {
  failedPayments: PropTypes.arrayOf(PropTypes.shape({})),
  setFailedPaymentsRetryStatus: PropTypes.func.isRequired,
  retryFailedPayments: PropTypes.func.isRequired,
  failedPaymentsRetryStatus: PropTypes.shape({}).isRequired,
  paymentMethods: PropTypes.arrayOf(PropTypes.shape({})),
  getFailedPayments: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
};

FailedPayments.defaultProps = {
  failedPayments: [],
  paymentMethods: [],
};

const mapStateToProps = state => ({
  failedPayments: failedPaymentsSelector(state),
  paymentMethods: paymentMethodsSelector(state),
  failedPaymentsRetryStatus: failedPaymentsRetryStatusSelector(state),
});

const mapDispatchToProps = {
  setFailedPaymentsRetryStatus: setFailedPaymentsRetryStatusAction,
  retryFailedPayments: retryFailedPaymentsAction,
  getFailedPayments: getFailedPaymentsListAction,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FailedPayments),
);
